var util = require('lib/util');

function camelToKebab(s) {
    return s.replace(/(\S)([A-Z])/g, function ($0, $1, $2) {
        return $1 + '-' + $2.toLowerCase();
    });
}

/*
    css({
        'selector': {                   // selector {}
            backgroundColor: "#FFF"
            '&': {
                'child_selector': {},   // selector child_selector {}
                '& > selector': {}      // selector > selector {}
            },
            '&:first-child': {}         // selector:first-child {}
        },
        '@media print': {               // @media print { selector {} }
            'selector': {}
        }
    })
*/

/**
 * @classdesc A helper object for managing CSS rules.
 * @class
 * @hideconstructor
 * @param {object} [rules] An object with CSS rules.
 * @param {*} [parent]
 */
function CSSObject(options, parent) {
    if (parent) {
        this.parent = parent;
    }
    /**
     * The rules property contains the CSS rules as a JavaScript object. 
     * 
     * The CSS property name should be written as camelCased name instead of kebab-cased (hyphen-delimited) name.
     * 
     * You can use '&' in CSS selector to indicate the selector of the parent rule.
     * 
     * @type {object}
     * @example
{
    body: {
        color: 'darkgray',
        backgroundColor: '#EDFFFF'
        '& > div': {
            fontWeight: 'bold',
            opacity: 0.5
        }
    }
}
     * @example <caption>CSS</caption>
body {
    color: darkgray;
    background-color: #EDFFFF;
}
body > div {
    font-weight: bold;
    opacity: 0.5;
}
     */
    this.rules = options || {};
    /**
     * Reference to `<style>` element in which CSS rules are rendered.
     * @type {HTMLElement}
     */
    this.style = null;
}

/**
 * Returns string representation for the CSS object.
 * 
 * @return {string} CSS syntax
 * @example
Cortona3DSolo.app.ui.css({body: { backgroundColor: 'red' } }).toString()
// -> "body { background-color: red; }"
 */
CSSObject.prototype.toString = function () {
    var syntax = '',
        rule,
        selector,
        prop,
        fullSelector,
        parent = this.parent,
        trim = /(^\s+|\s+$)/,
        children;
    for (selector in this.rules) {
        var isMedia = selector.indexOf('@media') === 0 && !parent;
        if (this.rules.hasOwnProperty(selector)) {
            if (syntax) {
                syntax += '\n';
            }
            if (parent) {
                fullSelector = selector.split(/\s*,\s*/).map(function (s) {
                    s = s.replace(trim, '');
                    return (s.indexOf('&') < 0) ? (parent + ' ' + s) : s.replace(/&/, parent);
                }).join(',');
            } else {
                fullSelector = selector.replace(trim, '');
            }
            syntax += fullSelector + ' {';
            if (isMedia) {
                syntax += '\n' + new CSSObject(this.rules[selector]);
            } else {
                children = [];
                rule = this.rules[selector];
                if (util.isObject(rule)) {
                    for (prop in rule) {
                        if (rule.hasOwnProperty(prop)) {
                            if (prop.indexOf('&') < 0) {
                                syntax += '\n' + camelToKebab(prop) + ': ' + rule[prop] + ';';
                            } else if (prop !== '&') {
                                children.push(prop);
                            }
                        }
                    }
                }
            }
            syntax += '\n}';
            if (!isMedia) {
                children.forEach(function (prop) {
                    var o = {};
                    o[prop] = rule[prop];
                    syntax += '\n' + new CSSObject(o, fullSelector);
                });
                if (util.isObject(rule['&'])) {
                    syntax += '\n' + new CSSObject(rule['&'], fullSelector);
                }
            }
        }
    }
    return syntax;
};

/**
 * Apply CSS rules to an HTML page.
 * 
 * @param {object} [rules] Additional rules for merging with existing ones. 
 * @return {CSSObject}
 * @example
var css = Cortona3DSolo.app.ui.css({body: { backgroundColor: 'red' } });
css.render({ body: { color: 'white' } });
// -> body { background-color: red; color: white; }
 */
CSSObject.prototype.render = function (options) {
    if (!this.style) {
        this.style = document.head.appendChild(document.createElement('style'));
        this.style.type = 'text/css';
    }
    if (options) {
        util.expand(this.rules, options);
    }
    this.style.innerHTML = this.toString();
    return this;
};

/**
 * Clears all CSS rules.
 * 
 * @return {CSSObject}
 */
CSSObject.prototype.clear = function () {
    this.rules = {};
    return this;
};

/**
 * Returns new instance of CSSObject.
 * 
 * @private
 * @param {object} [rules]
 * @return {CSSObject}
 */
function css(options) {
    return new CSSObject(options);
}

module.exports = css;